// CookieConsent.js
import React, { useState, useEffect } from "react";

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Vérifiez si le consentement a déjà été donné
    const cookieConsent = localStorage.getItem("cookieConsent");
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    // Sauvegardez le consentement dans le localStorage
    localStorage.setItem("cookieConsent", "true");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 w-full bg-gray-800 text-white p-4 flex flex-col xl:flex-row justify-between items-center gap-8 z-50">
      <p className="text-center">
        Ce site utilise des cookies pour vous offrir une meilleure expérience.
        En utilisant ce site, vous acceptez notre politique de cookies.
      </p>
      <div className="flex items-center gap-4">
        <button
          onClick={() => setIsVisible(false)}
          className="bg-white text-black px-4 py-2 rounded"
        >
          Refuser
        </button>
        <button
          onClick={handleAccept}
          className="bg-primary-100 text-white px-4 py-2 rounded"
        >
          Accepter
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
